import React, { useState, useEffect, Fragment } from 'react';
import { Container, Row, Col, FormGroup, Label, Input, Form, Button, Spinner } from 'reactstrap';
import classNames from 'classnames';
import Select from 'react-select';

import PointsImg        from "~/assets/images/profile/points.png";
import ReferralsImg     from "~/assets/images/profile/referrals.png";
import RedeemImg        from "~/assets/images/profile/redeem.png";
import DefaultAvatarImg from "~/assets/images/profile/defaultAvatar.png";

import ValidationGroup, { ValidatorMark } from "~/components/validation";
import Msg                    from "~/components/messages";
import OverlayModal           from "~/components/overlayModal";
import security               from "~/services/security";
import User                   from "~/services/user";
import Country                from "~/services/countries";

import PushSubscriptionButton from "./PushSubscribeButton";
import AvatarSelector         from "./AvatarSelector";
import UserLevel              from './UserLevel';
import Giveaway               from './Giveaway';


const Profile = ({})=> {

  const [overlayOpen  , setOverlayOpen  ] = useState(false);
  const [user         , setUser         ] = useState({});
  const [countries    , setCountries    ] = useState([]);
  const [profile      , setProfile      ] = useState({gender: "M", avatar: DefaultAvatarImg});
  const [loading      , setLoading      ] = useState(true);
  const [errors       , setErrors       ] = useState({});

  const currentUser = security.currentUserValue;

  const messagingApps = [
    { id: 1, label: "Telegram"           , icon: "social-telegram" },
    { id: 2, label: "WhatsApp"           , icon: "brand-whatsapp" },
    { id: 3, label: "Skype"              , icon: "social-skype" },
    { id: 4, label: "Facebook Messenger" , icon: "social-facebook-messenger" },
    { id: 5, label: "Viber"              , icon: "social-viber" },
    { id: 6, label: "WeChat"             , icon: "social-wechat" },
    { id: 7, label: "Line"               , icon: "brand-line-messenger" },
  ];

  useEffect(()=> {
    (async ()=> {
      setProfile(await User.profile() || {gender : "M", avatar: DefaultAvatarImg});
      setCountries(await Country.all());
      setUser(await User.account());
      setLoading(false);
    })();
  }, []);


  const changeProfile = (key, val)=> setProfile((prev)=> ({...prev, [key]: val}));

  const validation = ValidationGroup("Profile");

  const hasErrors = ()=> {

    const errorList = {
      ...validation("gender"           , profile.gender),
      ...validation("age"              , profile.age),
      ...validation("town"             , profile.town),
      ...validation("region"           , profile.region),
      ...validation("country"          , profile.country),
      ...validation("zipCode"          , profile.zipCode),
      ...validation("messagingId"      , profile.messagingId),
      ...validation("messagingNetwork" , profile.messagingNetwork),
    };

    setErrors(errorList);
    return Boolean(Object.keys(errorList).length);
  };


  const updateProfile = async (e)=> {
    e.preventDefault();

    if(hasErrors()) return;

    setLoading(true);

    await User.updateProfile(profile)
      .then((message)=> {Msg.profileUpdated(message) ; setLoading(false)})
      .catch(setErrors)
      .finally(()=> setLoading(false));
  };

  const countryLabel = ({ name })=> (
    <div className="d-flex"> <div>{ name }</div> </div>
  );

  const networkLabel = ({ label, icon })=> (
    <div className="d-flex">
      <i className={`icofont icofont-${icon} m-r-10 f-20`}></i>
      <div>{label}</div>
    </div>
  );

  const filterCountries = (options ,input)=> {
    return options.data.name.toLowerCase().includes(input.toLowerCase());
  };

  const selectStyle = {
    valueContainer:      (_)=> ({ ..._, top: -6 }),
    control:             (_, { selectProps: { height }})=> ({ ..._, height }),
    indicatorsContainer: (_, { selectProps: { height }})=> ({ ..._, height }),
  };


  if(loading) return null;

  return (
    <div className='profile-page'>

      <OverlayModal opened={overlayOpen} title="Profile Picture" onClose={()=>setOverlayOpen(false)}>
        <AvatarSelector selected={profile.avatar} setPicture={(picture)=> { changeProfile("avatar", picture); setOverlayOpen(false)}} />
      </OverlayModal>

      <Container fluid={true}>
        <div className="avatar-box">
          <h5> Receive 50 points in bonus </h5>
          <p>Complete your profile details and you will  receive a bonus of 50 points </p>
          {!loading && <img className="avatar" src={profile.avatar} onClick={()=>setOverlayOpen(true)} /> }

        </div>
        <h4 className="name"> {currentUser.firstName} {currentUser.lastName}</h4>
        <h6 className="text-center m-b-30"> Account ID: {user.id}</h6>

        <div className="stats">
          <div className="points">
            <img src={PointsImg} />
            <p className="mb-0">Points</p>
            <p className="mb-0"><strong>{user.points}</strong></p>
          </div>

          <div className="redeem">
            <img src={RedeemImg} />
            <p className="mb-0">Redeem</p>
            <p className="mb-0"><strong>${user.totalRedeemedRewards}</strong></p>
          </div>

          <div className="referrals">
            <img src={ReferralsImg} />
            <p className="mb-0">Referrals</p>
            <p className="mb-0"><strong >{user.totalReferrals}</strong></p>
          </div>
        </div>

        <PushSubscriptionButton user={user} />

        <UserLevel user={user} />

        <Giveaway/>

        <h5 className="m-t-30 m-b-10 text-center"> My Profile </h5>

        <Form className="theme-form" onSubmit={updateProfile}>

          <FormGroup>
            <Label className="col-form-label">Gender</Label>
            <Row>
              <Col xs="6">
                <div className={classNames("radio radio-primary", {selected: profile.gender == 'M' || !profile.gender})}>
                  <Input id="gender-m" type="radio" value="M" name="gender" onChange={(e)=> changeProfile("gender", e.target.value)} checked={profile.gender == 'M' || !profile.gender }  />
                  <Label className="mb-0" for="gender-m"> Male </Label>
                </div>
              </Col>
              <Col xs="6">
                <div className={classNames("radio radio-primary", {selected: profile.gender == 'F'})}>
                  <Input id="gender-f" type="radio"  value="F" name="gender" onChange={(e)=> changeProfile("gender", e.target.value)}  checked={profile.gender == 'F' } />
                  <Label className="mb-0" for="gender-f"> Female</Label>
                </div>
              </Col>
              <ValidatorMark val={profile.gender} name="gender" validation={validation} errors={errors} textOnly={true} />
            </Row>
          </FormGroup>

          <FormGroup>
            <Label className="col-form-label">Age</Label>
            <Input type="number"
              onInput={(e)=> changeProfile("age", e.target.value)}
              className={classNames({ valid: !validation("age", profile.age), 'is-invalid': errors.age})}
              placeholder="Age"
              defaultValue={profile.age}
            />
            <ValidatorMark val={profile.age} name="age" validation={validation} errors={errors} />
          </FormGroup>

          <Row>
            <Col xs="12" md="6">
              <FormGroup className="select-group">
                <Label className="col-form-label">Messaging Network</Label>
                <Select
                  options={messagingApps}
                  value={messagingApps.filter((app)=> app.id === profile.messagingNetwork)}
                  getOptionValue={(option)=> option.id}
                  onChange={(selection)=> changeProfile("messagingNetwork", selection.id)}
                  styles={selectStyle}
                  placeholder="Select Network"
                  formatOptionLabel={networkLabel}
                  height={40}
                />
                <ValidatorMark val={profile.messagingNetwork} name="messagingNetwork" validation={validation} errors={errors} textOnly={true} />
              </FormGroup>
            </Col>
            <Col xs="12" md="6">
              <FormGroup>
                <Label className="col-form-label">Messaging ID</Label>
                <Input type="text"
                  defaultValue={profile.messagingId}
                  onInput={(e)=> changeProfile("messagingId", e.target.value)}
                  className={classNames({ valid: !validation("messagingId", profile.messagingId), 'is-invalid': errors.messagingId}) }
                  placeholder="Messaging ID"
                />
                <ValidatorMark val={profile.messagingId} name="messagingId" validation={validation} errors={errors} />
              </FormGroup>
            </Col>
          </Row>

          <FormGroup>
            <Label className="col-form-label">Town</Label>
            <Input type="text"
              onInput={(e)=> changeProfile("town", e.target.value)}
              className={classNames({ valid: !validation("town", profile.town), 'is-invalid': errors.town}) }
              placeholder="Town"
              defaultValue={profile.town}
            />
            <ValidatorMark val={profile.town} name="town" validation={validation} errors={errors} />

          </FormGroup>

          <FormGroup>
            <Label className="col-form-label">Region</Label>
            <Input type="text"
              onInput={(e)=> changeProfile("region", e.target.value)}
              className={classNames({ valid: !validation("region", profile.region), 'is-invalid': errors.region}) }
              placeholder="Region"
              defaultValue={profile.region}
            />
            <ValidatorMark val={profile.region} name="region" validation={validation} errors={errors} />
          </FormGroup>

          <FormGroup className="select-group">
            <Label className="col-form-label">Country</Label>
            <Select
              styles={selectStyle}
              filterOption={filterCountries}
              placeholder="Select country"
              options={countries}
              height={40}
              value= {countries.filter(country => country.cc === profile.country)}
              formatOptionLabel={countryLabel}
              getOptionValue={(option)=>option.cc}
              onChange={(selection) => changeProfile("country", selection.cc)}
            />
            <ValidatorMark val={profile.country} name="country" validation={validation} errors={errors} textOnly={true} />
          </FormGroup>

          <FormGroup>
            <Label className="col-form-label">Zip Code</Label>
            <Input type="text"
              onInput={(e)=> changeProfile("zipCode", e.target.value)}
              className={classNames({ valid: !validation("zipCode", profile.zipCode), 'is-invalid': errors.zipCode}) }
              placeholder="Zip Code"
              defaultValue={profile.zipCode}
            />
            <ValidatorMark val={profile.zipCode} name="zipCode" validation={validation} errors={errors} />
          </FormGroup>

          <FormGroup>
            <Label className="col-form-label">Phone number</Label>
            <Input type="tel"
              onInput={(e)=> changeProfile("phone", e.target.value)}
              className={classNames({ valid: profile.phone && !validation("phone", profile.phone), 'is-invalid': errors.phone}) }
              placeholder="Enter your phone number"
              defaultValue={profile.phone}
            />
            <ValidatorMark val={profile.phone} name="phone" validation={validation} errors={errors} />
          </FormGroup>

          <FormGroup>
            <Label className="col-form-label ">Mobile phone model</Label>
            <Input type="tel"
              onInput={(e)=> changeProfile("phoneModel", e.target.value)}
              className={classNames({ valid: profile.phoneModel && !validation("phoneModel", profile.phoneModel), 'is-invalid': errors.phoneModel}) }
              placeholder="Enter your phone model"
              defaultValue={profile.phoneModel}
            />
            <ValidatorMark val={profile.phoneModel} name="phoneModel" validation={validation} errors={errors} />
          </FormGroup>

          <FormGroup>
            <Button disabled={loading} color="primary" className="btn-block m-t-30" type="submit">
              { loading ? <Spinner size="sm" /> : "Update Profile" }
            </Button>
          </FormGroup>
        </Form>
      </Container>
    </div>
  );
}

export default Profile;
